import { Box, Skeleton } from '@mui/material';

// Kept as the existing global-loading component name so callers do not need to
// know whether the backdrop is showing a page or a settings request.
export default function JKLoader() {
  return (
    <Box role="status" aria-label="Loading" sx={{ width: 280 }}>
      <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
    </Box>
  );
}
